import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textXSObj } = typographyStyles;

export const listItemCss = {
  listStyle: "none",
  borderRadius: "2px",
  padding: "8px 16px",
  margin: "8px 0",
  backgroundColor: colors.ui.neutral[25],
};

export const questionCss = [
  {
    color: colors.ui.neutral[400],
  },
  textXSObj,
];

export const checkboxCss = [
  {
    padding: 0,
    marginTop: "6px",
    textTransform: "uppercase",
    fontWeight: "bold",
    letterSpacing: "1px",
  },
  textXSObj,
];
